import { createSelector } from "@reduxjs/toolkit";

export const getLanguagesState = (state) => state.getLanguages;
export const languageState = createSelector(
  getLanguagesState,
  (state) => state
);
